export const themeClassName = {
  host: 'host-theme',
  guest: 'guest-theme',
} as const;
